<template>
    <div>
        <span>
        <span @click="showDetail">详情</span>
        <Modal
            v-model="isShow"
            title="数据详情">
            <div>
                <div style="color:red">{{errorInfo}}</div>
                <Input v-model="dataStr" type="textarea" :autosize="{minRows: 2,maxRows: 5}" />
            </div>
        </Modal>
    </span>
        
    </div>
</template>
<script>
export default {
    props:['value'],
    data() {
        return {
            isShow:false,
            errorInfo:''
        }
    },
    computed:{
        dataStr:{
           get(){
               try {
                   let str = JSON.stringify(this.value);
                   return str
               } catch (error) {
                   return 'none'
               }
               
           },
           set(v){
               try {
                   this.errorInfo = '';
                   let vv = JSON.parse(v)
                   this.$emit('input', vv)
                   this.$emit('save');
               } catch (error) {
                   console.log('json格式错误');
                   this.errorInfo = error.message;
               }
           }
        }
    },
    methods: {
        showDetail(){
            this.isShow = true;
        },
    },

}
</script>